// extracted by mini-css-extract-plugin
module.exports = {"container":"Restore_container__39wK0","spinner":"Restore_spinner__EEu78"};